
var frm = $('#formFacaParte');

var modal = new bootstrap.Modal(document.getElementById('modalFacaParte'));

(function () {
    'use strict'
  
    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    var forms = document.querySelectorAll('.validation-faca-parte')
  
    // Loop over them and prevent submission
    Array.prototype.slice.call(forms)
      .forEach(function (form) {
        form.addEventListener('submit', function (event) {
            event.preventDefault();
            event.stopPropagation();

            if (form.checkValidity()) {
                $('#loader-spinner').show();
                $('#btn-submit').attr("disabled","disabled");

                $.ajax({
                    type: frm.attr('method'),
                    url: frm.attr('action'),
                    data: frm.serialize(),
                    success: function (data) {
                        modal.hide();
                        modalFormSucesso.show();                       
                    },
                    error: function (data) {},
                });
            }
            form.classList.add('was-validated');
        }, false);
      })
})();